import { Phase } from "@1games-ru/region-shared/dist/enums/death/phase";
import { AnimatePresence, motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  isWaitingAmbulance?: boolean;
  ambulanceIsComing?: boolean;
  phase: Phase;
};
export default function DeathScreenTitle({
  className,
  phase,
  isWaitingAmbulance,
  ambulanceIsComing,
}: Props) {
  const { t } = useTranslation("deathScreen");

  return (
    <motion.div
      initial={{ opacity: 0, translateY: "-100%" }}
      animate={{ opacity: 1, translateY: "none" }}
      transition={{ duration: 0.5, type: "spring" }}
      exit={{ opacity: 0, translateY: "-100%" }}
      className={cn("flex flex-col items-center gap-1", className)}
    >
      <div className="relative h-[2.875rem]">
        <AnimatePresence>
          {phase === Phase.CriticalCondition ? (
            <motion.div
              initial={{ opacity: 0, translateX: "-50%" }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.3,
              }}
              exit={{ opacity: 0, translateX: "none" }}
              className="absolute top-0 text-white text-[2.375rem] font-extrabold w-max"
            >
              {t("deathScreen.criticalCondition")}
            </motion.div>
          ) : null}
        </AnimatePresence>

        <AnimatePresence>
          {phase === Phase.Unconscious ? (
            <motion.div
              initial={{ opacity: 0, translateX: "-50%" }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.3,
              }}
              exit={{ opacity: 0, translateX: "none" }}
              className="absolute top-0 text-white text-[2.375rem] font-extrabold w-max"
            >
              {t("deathScreen.unconscious")}
            </motion.div>
          ) : null}
        </AnimatePresence>
      </div>
      <div className="relative h-[2.375rem]">
        <AnimatePresence>
          {ambulanceIsComing ? (
            <motion.div
              initial={{ opacity: 0, translateX: "-50%" }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.3,
              }}
              exit={{ opacity: 0, translateX: "none" }}
              className="absolute top-0 text-[#84FF97] text-16 font-medium w-max"
            >
              {t("deathScreen.ambulanceIsComing")}
            </motion.div>
          ) : null}
        </AnimatePresence>

        <AnimatePresence>
          {!ambulanceIsComing && isWaitingAmbulance ? (
            <motion.div
              initial={{ opacity: 0, translateX: "-50%" }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.3,
              }}
              exit={{ opacity: 0, translateX: "none" }}
              className="absolute top-0 text-white text-16 font-medium w-max"
            >
              {t("deathScreen.youAreWaitingAmbulance")}
            </motion.div>
          ) : null}
        </AnimatePresence>

        <AnimatePresence>
          {!ambulanceIsComing && !isWaitingAmbulance ? (
            <motion.div
              initial={{ opacity: 0, translateX: "-50%" }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.3,
              }}
              exit={{ opacity: 0, translateX: "none" }}
              className="absolute top-0 text-white text-16 font-medium w-max"
            >
              {t("deathScreen.needHelp")}
            </motion.div>
          ) : null}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
